import React from "react";
import styled, { css } from "styled-components";

interface TagPageListItemProps {
  title: string;
  children: React.ReactNode;
}

const TagPageListItem = ({ title, children }: TagPageListItemProps) => {
  return (
    <TagListItemLayout>
      <h2>{title}</h2>
      <div>{children}</div>
    </TagListItemLayout>
  );
};

const TagListItemLayout = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  > div {
    flex-grow: 1;
    width: 100%;
  }
  h2 {
    ${({ theme }) => theme.typography.body1.medium}
    min-width: 12rem;
  }

  ${({ theme }) => css`
    ${theme.media.small} {
      flex-direction: column;
      align-items: flex-start;
      ${theme.typography.body1.regular}

      h2 {
        ${theme.typography.body3.medium}
        color: ${theme.color.text.secondary};
      }
    }
  `}
`;

export default TagPageListItem;
